var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_103_100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.9062 0H25.0938C13.444 0 4 9.44399 4 21.0938V68.9062C4 80.556 13.444 90 25.0938 90H72.9062C84.556 90 94 80.556 94 68.9062V21.0938C94 9.44399 84.556 0 72.9062 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9062 0H25.0938C13.444 0 4 9.44399 4 21.0938V68.9062C4 80.556 13.444 90 25.0938 90H72.9062C84.556 90 94 80.556 94 68.9062V21.0938C94 9.44399 84.556 0 72.9062 0Z",
    fill: "#0A66C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9389 76.5299H79.2291C79.602 76.5299 79.9596 76.3818 80.2233 76.1181C80.4871 75.8545 80.6353 75.4969 80.6354 75.124L80.6406 53.3827C80.6406 42.0191 78.192 33.2845 64.9124 33.2845C59.8643 33.0968 55.1038 35.6991 52.535 40.0444C52.5224 40.0655 52.5033 40.0819 52.4805 40.0911C52.4578 40.1003 52.4326 40.1019 52.4089 40.0954C52.3852 40.089 52.3642 40.075 52.3492 40.0556C52.3342 40.0362 52.326 40.0123 52.3258 39.9878V35.7398C52.3258 35.3669 52.1776 35.0092 51.9139 34.7455C51.6502 34.4818 51.2925 34.3336 50.9195 34.3336H41.1542C40.7812 34.3336 40.4235 34.4818 40.1598 34.7455C39.8961 35.0092 39.7479 35.3669 39.7479 35.7398V75.1219C39.7479 75.4948 39.8961 75.8525 40.1598 76.1162C40.4235 76.38 40.7812 76.5281 41.1542 76.5281H51.4437C51.8167 76.5281 52.1744 76.38 52.4381 76.1162C52.7018 75.8525 52.85 75.4948 52.85 75.1219V55.6548C52.85 50.1504 53.8941 44.8196 60.7183 44.8196C67.4454 44.8196 67.5326 51.1182 67.5326 56.0113V75.1236C67.5326 75.4966 67.6808 75.8543 67.9445 76.118C68.2082 76.3817 68.5659 76.5299 68.9389 76.5299ZM17.3594 20.963C17.3594 25.1339 20.7931 28.5659 24.9644 28.5659C29.1346 28.5655 32.5662 25.1314 32.5662 20.9612C32.5655 16.791 29.1336 13.3594 24.963 13.3594C20.7913 13.3594 17.3594 16.792 17.3594 20.963ZM19.8059 76.5299H30.1091C30.4821 76.5299 30.8398 76.3817 31.1035 76.118C31.3672 75.8543 31.5154 75.4966 31.5154 75.1236V35.7398C31.5154 35.3669 31.3672 35.0092 31.1035 34.7455C30.8398 34.4818 30.4821 34.3336 30.1091 34.3336H19.8059C19.4329 34.3336 19.0753 34.4818 18.8115 34.7455C18.5478 35.0092 18.3996 35.3669 18.3996 35.7398V75.1236C18.3996 75.4966 18.5478 75.8543 18.8115 76.118C19.0753 76.3817 19.4329 76.5299 19.8059 76.5299Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_103_100",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_103_100"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_103_100",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8b9937e704ecc837d5bc64aad94ecefc.svg";
export { ForwardRef as ReactComponent };